module.exports = __webpack_public_path__ + "img/t3-c1.3601d1b6.png";